import { useProcess } from '@fasstech/oip-starter-utils/app';
import { isNil, propOr } from 'ramda';
import { isSelfcareFloorView, isViewBeforeSelfcareFloor } from '@@viewEnums';

/**
 * Relais selfcare : une fois la main donnée au client, celui-ci ne peut plus
 * revenir avant la vue où le relais a été donné
 */
export const useSelfcareRelay = () => {
  const { context } = useProcess();

  const floorViewId = propOr(null, 'selfcareFloorViewId', context);
  const currentViewId = propOr(null, 'viewId', context);

  return {
    floorViewId,
    currentViewId,
    isRelayGranted: !isNil(floorViewId),
    previousIsBlocked: isSelfcareFloorView(currentViewId, floorViewId),
    isEditBlocked: (targetViewId) =>
      isViewBeforeSelfcareFloor(targetViewId, floorViewId)
  };
};

export default useSelfcareRelay;
